import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClientKeys } from "web_myplann/Api/Client/ClientKeys";
import { deleteClientIdentificationDocumentsIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDeleteIdentificationDocumentMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((id: number) =>
			deleteClientIdentificationDocumentsIdV2(id),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ClientKeys.identificationDocumentsAll,
			});
			queryClient.invalidateQueries({ queryKey: ClientKeys.all });
		},
	});
};
